import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FiPaperclip, FiSave } from 'react-icons/fi';
import { adminAPI } from '../../../services/api';
import { prepareHomeworkHtml } from '../../../utils/homeworkContent';

const API_ORIGIN = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/api\/?$/, '');

const HomeworkCheckingDetailPage = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [submission, setSubmission] = useState(null);
    const [teacherComment, setTeacherComment] = useState('');
    const [teacherRating, setTeacherRating] = useState('');
    const [saving, setSaving] = useState(false);

    const formatStatus = (status) => {
        const map = {
            pending: 'Черновик',
            submitted: 'На проверке',
            reviewed: 'Проверено',
            checked: 'Проверено',
            needs_revision: 'Нужна доработка'
        };
        return map[status] || status || '—';
    };

    const load = async () => {
        setLoading(true);
        try {
            const res = await adminAPI.getHomeworkCheckingSubmission(id);
            const sub = res.data.submission;
            setSubmission(sub);
            setTeacherComment(sub.teacher_comment || '');
            setTeacherRating(sub.teacher_rating ?? '');
        } catch (e) {
            console.error(e);
            alert(e.response?.data?.error || 'Не удалось загрузить ответ по ДЗ');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const handleReview = async () => {
        if (!submission) return;
        setSaving(true);
        try {
            await adminAPI.reviewHomeworkCheckingSubmission(submission.id, {
                teacher_comment: teacherComment,
                teacher_rating: teacherRating === '' ? null : Number(teacherRating)
            });
            navigate('/admin/checking/homework', { replace: true });
        } catch (e) {
            console.error(e);
            alert(e.response?.data?.error || 'Не удалось сохранить проверку');
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return <div style={{ padding: 20 }}>Загрузка...</div>;
    }

    if (!submission) {
        return <div style={{ padding: 20 }}>Ответ не найден</div>;
    }

    return (
        <div style={{ maxWidth: 1200, margin: '-20px auto 0', padding: '0 20px 20px' }}>
            <h1 style={{ margin: '0 0 10px 0' }}>Проверка ДЗ</h1>
            <div style={{ color: '#666', marginBottom: 18 }}>
                <div><strong>Ученик:</strong> {submission.first_name || ''} {submission.last_name || ''} ({submission.username})</div>
                <div><strong>ДЗ:</strong> {submission.homework_title}</div>
                <div><strong>Статус:</strong> {formatStatus(submission.status)}</div>
            </div>

            <div className="card" style={{ padding: 18, marginBottom: 18 }}>
                <h3 style={{ marginTop: 0 }}>Текст задания</h3>
                <div
                    style={{ lineHeight: 1.6 }}
                    dangerouslySetInnerHTML={{
                        __html: prepareHomeworkHtml(submission.homework_description, 'admin')
                    }}
                />
            </div>

            <div className="card" style={{ padding: 18, marginBottom: 18 }}>
                <h3 style={{ marginTop: 0 }}>Ответ ученика</h3>
                <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
                    {submission.submission_text || '—'}
                </div>

                <div style={{ marginTop: 14 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, color: '#555' }}>
                        <FiPaperclip /> Вложения
                    </div>
                    {Array.isArray(submission.attachments) && submission.attachments.length > 0 ? (
                        <ul style={{ margin: 0, paddingLeft: 18 }}>
                            {submission.attachments.map((a, idx) => (
                                <li key={idx}>
                                    <a href={`${API_ORIGIN}${a.url}`} target="_blank" rel="noopener noreferrer">
                                        {a.name || a.url}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <div style={{ color: '#888' }}>—</div>
                    )}
                </div>
            </div>

            <div className="card" style={{ padding: 18 }}>
                <h3 style={{ marginTop: 0 }}>Проверка</h3>

                <div className="form-group">
                    <label>Комментарий преподавателя</label>
                    <textarea
                        value={teacherComment}
                        onChange={(e) => setTeacherComment(e.target.value)}
                        rows={5}
                        placeholder="Введите комментарий..."
                    />
                </div>

                <div className="form-group">
                    <label>Оценка (0–10)</label>
                    <input
                        type="number"
                        min="0"
                        max="10"
                        value={teacherRating}
                        onChange={(e) => setTeacherRating(e.target.value)}
                        placeholder="Например: 8"
                    />
                </div>

                <button
                    onClick={handleReview}
                    disabled={saving}
                    className="btn-save"
                    style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}
                >
                    <FiSave /> {saving ? 'Сохранение...' : 'Отметить как проверено'}
                </button>
            </div>
        </div>
    );
};

export default HomeworkCheckingDetailPage;

